import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=d201021a&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"
import style0 from "./Icons.scss?vue&type=style&index=0&id=d201021a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d201021a",
  null
  
)

export default component.exports